import Footer from "../../components/Footer";
import HeaderCarousel from "./HeaderCarousel";
import Navbar from "../../components/Navbar";
import Products from "./Products";
import StyleCutting from "./StyleCutting";

export default function Home () {
    return (
        <div>
            <Navbar/>
            <HeaderCarousel/>
            <StyleCutting/>
     {/*     <Products /> */}
            <Footer/>
        </div>
    )
}